import { constant } from "common/constant";
import { toast } from "react-toastify";

export const HandleCopy = (value) => {
    navigator.clipboard.writeText(value && value);
    toast.success(constant.copied)
}